import React, { useMemo } from 'react';
import { isCustomerFromGensler } from '@mb/lib/customer';
import { Divider } from '@mui/material';
import { useSelector } from 'react-redux';
import { SwitchRenderer } from './SwitchRenderer';
import {
  currentFiltersSelector,
  residentialCommercialFacetSelector,
} from '../../redux/selectors/filtersSelector';

import { splitSwitches } from '../../utils';
import { FiltersRenderer } from './renderers/FiltersRenderer';

const isGenslerUser = isCustomerFromGensler();

type FiltersListContainerProps = {
  isMobile?: boolean;
  onCollapseChange?: () => void;
};

export const FiltersListContainer = ({
  isMobile,
  onCollapseChange,
}: FiltersListContainerProps) => {
  const filters = useSelector(currentFiltersSelector);
  const residentialCommercialFacet = useSelector(
    residentialCommercialFacetSelector,
  );

  const [switches, filterList] = useMemo(() => {
    return splitSwitches(filters || []);
  }, [filters]);

  const finalSwitches = useMemo(() => {
    const facetValues =
      residentialCommercialFacet?.field != null
        ? residentialCommercialFacet?.values
        : [];
    const togglesList = [...(facetValues || []), ...switches];

    // Filter toggles based on user type
    const filteredToggles = togglesList.filter((item) => {
      if (item.field !== 'is_gps_compliant') {
        return true;
      }
      return isGenslerUser;
    });

    // Move 'is_gps_compliant' toggle to the first position if present
    const gpsToggle = filteredToggles.find(
      (item) => item.field === 'is_gps_compliant',
    );
    const otherToggles = filteredToggles.filter(
      (item) => item.field !== 'is_gps_compliant',
    );

    return gpsToggle ? [gpsToggle, ...otherToggles] : otherToggles;
  }, [switches, residentialCommercialFacet]);

  return (
    <>
      <SwitchRenderer switches={finalSwitches} />
      <Divider sx={dividerSx} />
      {filters?.length !== 0 ? (
        <FiltersRenderer
          filters={filterList}
          isMobile={isMobile}
          onCollapseChange={onCollapseChange}
        />
      ) : null}
    </>
  );
};

///
const dividerSx = {
  marginBottom: '0.5em',
};
